import { FunctionComponent, ReactElement } from "react";
import { Link } from "react-router-dom";

import { StyledMenuSelectorLink, StyledSelectedUnderline, StyledNumber, StyledIcon } from "./styles";

interface IProps extends Omit<typeof Link, "$$typeof"> {
  icon: ReactElement;
  link: string;
  label: string;
  isActive?: boolean;
  notificationsAmount?: number;
  onClick?: () => void;
  title?: string;
  role?: string;
}

const MenuItem: FunctionComponent<IProps> = ({ icon, isActive, label, link, notificationsAmount, ...props }) => (
  <StyledMenuSelectorLink to={link} title={`Go to ${label}`} aria-label={`Go to ${label}`} {...props}>
    <StyledIcon>{icon}</StyledIcon>
    {!!notificationsAmount && <StyledNumber className="notification-dot">{notificationsAmount}</StyledNumber>}
    {isActive && <StyledSelectedUnderline className="active-underline" />}
  </StyledMenuSelectorLink>
);

export default MenuItem;
